/** @file findClip: resolves a clip reference (a name, then an id) in a puppet document. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import type { Clip } from '@zilo/pose3d-format/types/clip';
import { throwError } from '@zilo/pose3d-std/errors/throwError';
import type { PuppetDoc } from './puppetDoc';

/** The clip named `ref`, else the clip whose id is `ref`, with its name; `NOT_FOUND` (hint: the names) otherwise. */
export function findClip(doc: Pick<PuppetDoc, 'clips'>, ref: string, path = '/input/clip'): { name: string; clip: Clip } {
  const named = doc.clips[ref];
  if (named !== undefined) return { name: ref, clip: named };
  const byId = Object.entries(doc.clips).find(([, c]) => c.id === ref);
  if (byId !== undefined) return { name: byId[0], clip: byId[1] };
  const names = Object.keys(doc.clips).join(', ');
  return throwError(ERROR_CODES.NOT_FOUND, { clip: ref }, { path, hint: `clips: ${names === '' ? '(none)' : names}` });
}
